<template>
	<LayoutOffcanvasStandard ref="offcanvas" id="sale-modal-show" title="Detalles de la venta" bodyClass="container-md vstack gap-5">
		<template #body v-if="sale">
			<SaleCommonDetail :sale="sale" />
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref } from 'vue';

	export default {
		setup() {
			const offcanvas = ref(null);
			const sale = ref(null);

			const show = (saleData) => {
				sale.value = saleData;
				offcanvas.value.offcanvas.show();
			}

			return { offcanvas, sale, show };
		}
	}
</script>